export { default as ReceiptHeadInfo, RECEIPT_ORDER_DETAILS_TITLE_NATIVE_ID } from './receipt-head-info';
